import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { TomadaDeContaService } from '../../../../providers/tce-service';
import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";

import { ModalPreVisualizarTcePage } from '../../../modais/modal-pre-visualizacao/tce/modal-pv-tce';

@Component({
  selector: 'page-tce-resumo-acoes',
  templateUrl: 'tce-resumo-acoes.html',
  providers: [
    TomadaDeContaService
  ]
})
export class TomadaDeContaResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  loading: boolean = true;
  tituloPagina: string = "";
  // isJurisdicionado: boolean;
  constructor(
    private tomadaDeContaService: TomadaDeContaService,
    public alertService: AlertService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(9);
  }

  carregarDados() {

    // futura lista de analise dos analistas
    if (!this.isJurisdicionado) {
      this.tomadaDeContaService.obterListaAnalisesAnalista().subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if ((x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) || x.cdAnalise == 210)  {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    } else {
      // Acesso aos jurisdicionados
      this.tomadaDeContaService.obterListaAnalisesJuridicionado().subscribe(data => {
        this.listaAnalises = data;

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
  }

  redirecionarParaAnalise(analise) {
    analise.cdModulo = this.tomadaDeContaService.idPaginaTomadaDeConta;
    this.menuService.redirecionarSubPagina(this.tomadaDeContaService.obterIdPaginaTomadaDeConta(), analise);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 9).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'TCE',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  previsualizarCertificado() {

    let modal = this.modalCtrl.create(ModalPreVisualizarTcePage, {});
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'TCE',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/tce/tce-resumo-acoes/tce-resumo-acoes.ts